<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Serviços</h2>
  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue">
        <img src="assets/images/services/service-1.webp" alt="Back-End" />
        <h3 class="mb-3 mt-0">Back-End</h3>
        <p class="mb-0">
          Desenvolvimento de APIs e sistemas robustos utilizando <strong>.NET</strong> e <strong>Node.js</strong>,
          focando em performance, segurança e escalabilidade.
        </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-pink bg-pink">
        <img src="assets/images/services/service-2.webp" alt="Front-End" />
        <h3 class="mb-3 mt-0">Front-End</h3>
        <p class="mb-0">
          Criação de interfaces modernas e responsivas com <strong>Angular</strong>, <strong>HTML5</strong>,
          <strong>CSS3</strong> e <strong>Bootstrap</strong>, garantindo ótima experiência ao usuário.
        </p>
      </div>
    </div>

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/services/service-3.webp" alt="Fullstack" />
        <h3 class="mb-3 mt-0">Fullstack</h3>
        <p class="mb-0">
          Integração completa entre front-end e back-end para soluções escaláveis, combinando <strong>Angular</strong>,
          <strong>.NET</strong> e <strong>Node.js</strong>.
        </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>
  </div>

  <br>

  <div class="row">
    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-blue bg-blue">
        <img src="assets/images/services/service-4.webp" alt="Banco de Dados" />
        <h3 class="mb-3 mt-0">Banco de Dados</h3>
        <p class="mb-0">
          Modelagem, otimização e manutenção de bancos de dados relacionais e NoSQL, garantindo performance e
          integridade dos dados.
        </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center text-light shadow-pink bg-pink">
        <img src="assets/images/services/service-5.webp" alt="Cloud" />
        <h3 class="mb-3 mt-0">Cloud</h3>
        <p class="mb-0">
          Deploy e gerenciamento de aplicações em nuvem utilizando <strong>AWS</strong>, <strong>Azure</strong> e
          <strong>Google Cloud</strong>, garantindo escalabilidade e segurança.
        </p>
      </div>
    </div>

    <div class="col-md-4">
      <!-- service box -->
      <div class="service-box rounded data-background padding-30 text-center shadow-yellow bg-yellow">
        <img src="assets/images/services/service-6.webp" alt="DevOps" />
        <h3 class="mb-3 mt-0">DevOps</h3>
        <p class="mb-0">
          Automação de processos de desenvolvimento, integração contínua, deploy contínuo e monitoramento de aplicações
          para máxima eficiência.
        </p>
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>
  </div>

  <div class="mt-5 text-center">
    <p class="mb-0">
      Procurando um trabalho personalizado?
      <a href="javascript:" (click)="scrollTo('contact')">
        Clique aqui
      </a>
      para entrar em contato comigo! 👋
    </p>
  </div>

  <br>
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Experiências</h2>
  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-12">
      <!-- responsive spacer -->
      <div class="spacer-30 d-md-none d-lg-none"></div>

      <!-- timeline wrapper -->
      <div class="timeline exp bg-white shadow-dark rounded padding-30 overflow-hidden">

        <!-- Hypeone -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">11/2022 - Atual</span>
            <h3 class="title">Analista de Desenvolvimento de Sistemas</h3>
            <p><strong>Hypeone | Neo BPO</strong> – São Paulo, SP (Remoto)</p>
            <ul>
              <li>Atuação como Desenvolvedor Full Stack na equipe de produtos da Nex | Send.</li>
              <li>Criação e aprimoramento contínuo de um sistema web de CRM para call centers.</li>
              <li>Uso de <strong>.NET, NodeJS, Laravel e Angular</strong> em ambiente ágil (Azure DevOps e AWS).</li>
              <li>Entrega de soluções robustas, escaláveis e de alta qualidade.</li>
            </ul>
          </div>
        </div>

        <!-- PTC Group -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">06/2022 - 10/2022</span>
            <h3 class="title">Analista de Desenvolvimento de Sistemas</h3>
            <p><strong>PTC Group</strong> – Betim, MG (Remoto)</p>
            <ul>
              <li>Desenvolvimento back-end em <strong>NestJS</strong> e <strong>PostgreSQL</strong>.</li>
              <li>Implementação de novas funcionalidades e correções críticas em ambiente ágil (Jira).</li>
              <li>Atuação em segurança da informação em fintech de serviços financeiros.</li>
              <li>Contribuição para implantação em ambiente AWS com foco em escalabilidade.</li>
            </ul>
          </div>
        </div>

        <!-- Code7 -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">09/2020 - 06/2022</span>
            <h3 class="title">Analista de Desenvolvimento de Sistemas</h3>
            <p><strong>Code7 Software e Plataformas de Tecnologia</strong> – Florianópolis, SC (Remoto)</p>
            <ul>
              <li>Desenvolvimento de aplicativos desktop para call centers com <strong>ASP .NET</strong> e SQL Server.
              </li>
              <li>Resolução de erros em fila N3 com foco em performance e estabilidade.</li>
              <li>Implantação de serviços no IIS e Windows Services garantindo segurança e desempenho.</li>
            </ul>
          </div>
        </div>

        <!-- Floripark -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.6s">
          <div class="content">
            <span class="time">04/2019 - 08/2020</span>
            <h3 class="title">Aprendiz em Desenvolvimento</h3>
            <p><strong>Floripark Empreendimentos e Serviços LTDA</strong> – Florianópolis, SC</p>
            <ul>
              <li>Desenvolvimento de sistema web interno com <strong>Angular 2+</strong>.</li>
              <li>Integração via APIs REST utilizando <strong>Spring Framework</strong>.</li>
            </ul>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>
  </div>
</div>